import React, { Component } from 'react'
import {GatsbyImage, getImage} from "gatsby-plugin-image";

class PostCover extends Component {
  render() {
    const { fileEdges, postNode, coverHeight, coverClassName } = this.props

    const post = postNode.frontmatter ? postNode.frontmatter : postNode
    let postCover
    if (post.assets) {
      postCover = post.assets.hero
    } else if (post.image) {
      postCover = post.image.url
    } else {
      postCover = post.cover
    }
    const cover = fileEdges.find(fileNode => fileNode.node.absolutePath.endsWith(postCover))
    const image = getImage(cover.node.childImageSharp)
    return (
      <GatsbyImage
        image={image}
        className="lightboxIgnore"
        style={{ height: coverHeight, width: '100%' }}
        alt="cover image" />
    )
  }
}

export default PostCover
